import React from "react";
import { format } from "date-fns";

const PatientDetails = ({
  patientData,
  isVertical21cm,
}: {
  patientData: any;
  isVertical21cm: boolean;
}) => {
  const containerStyle = {
    display: "grid",
    gridTemplateColumns: isVertical21cm ? "3fr 2fr" : "1fr 1fr",
    width: "100%",
    marginTop: "4px",
    fontSize: "12px",
    lineHeight: "14px",
  };

  const rowStyle = {
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "nowrap",
  };

  const labelStyle = {
    width: "115px",
    whiteSpace: "nowrap",
    fontSize: "10px",
    flexShrink: 0,
  };

  const labelFirstStyle = {
    width: "116px",
    marginLeft: "30px",
    whiteSpace: "nowrap",
    fontSize: "10px",
    flexShrink: 0,
  };

  const valueStyle = {
    fontWeight: "bold",
    whiteSpace: "normal",
    overflowWrap: "break-word",
    wordBreak: "break-word",
  };

  const valueRowStyle = {
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "nowrap",
    flex: 1,
    minWidth: 0,
  };

  const colonStyle = {
    flexShrink: 0,
    fontWeight: "bold",
    marginRight: "4px",
  };

  const valueTextStyle = {
    fontWeight: "bold",
    flex: 1,
    minWidth: 0,
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "break-word",
  };

  const renderValue = (content: any) => (
    <span style={valueRowStyle} className="value-row">
      <span style={colonStyle} className="value-colon">
        :
      </span>
      <span style={valueTextStyle} className="value-text">
        {content}
      </span>
    </span>
  );

  return (
    <>
      <div style={containerStyle}>
        <div style={rowStyle}>
          <span className="left-label-style" style={labelStyle}>
            EMR #{" "}
          </span>
          <span style={valueStyle}>
            {patientData?.patientDetails?.map((item, index) => (
              <div key={index}>: {item?.patientNumber}</div>
            ))}
          </span>
        </div>

        <div style={rowStyle}>
          <span className="right-label-style" style={labelFirstStyle}>
            DATE{" "}
          </span>
          <span style={valueStyle}>
            :{" "}
            {patientData?.opdDetails?.caseDate
              ? patientData?.opdDetails?.caseDate
              : ""}
          </span>
        </div>

        <div style={rowStyle}>
          <span className="left-label-style" style={labelStyle}>
            NAME (GENDER / AGE)
          </span>
          <span style={valueStyle}>
            {patientData?.patientDetails?.map((item, index) => (
              <div key={index}>
                {renderValue(
                  <>
                    {item?.fullName} ({item?.gender}
                    {item?.ageYear > 0 || item?.ageMonth > 0 || item?.ageDay > 0
                      ? " / "
                      : ""}
                    {item?.ageYear > 0 ? item?.ageYear?.toString() + "y" : ""}{" "}
                    {item?.ageMonth > 0 ? item?.ageMonth?.toString() + "m" : ""}{" "}
                    {item?.ageDay > 0 ? item?.ageDay?.toString() + "d" : ""})
                  </>,
                )}
              </div>
            ))}
          </span>
        </div>

        <div style={rowStyle}>
          <span className="right-label-style" style={labelFirstStyle}>
            OPD CASE #{" "}
          </span>
          <span style={valueStyle}>
            : {patientData?.opdDetails?.caseNumber}
          </span>
        </div>

        {/* <div style={rowStyle}>
          <span style={labelStyle}>GENDER / AGE </span>
          <span style={valueStyle}>
            {patientData?.patientDetails?.map((item, index) => (
              <div key={index}>
                : {item?.gender}
                {item?.ageYear > 0 || item?.ageMonth > 0 || item?.ageDay > 0 ? ' / ' : ''}
                {item?.ageYear > 0 ? item?.ageYear?.toString() + 'y' : ''} {item?.ageMonth > 0 ? item?.ageMonth?.toString() + 'm' : ''} {item?.ageDay > 0 ? item?.ageDay?.toString() + 'd' : ''}
              </div>
            ))}
          </span>
        </div> */}

        <div style={rowStyle}>
          <span className="left-label-style" style={labelStyle}>
            MOBILE NO.{" "}
          </span>
          <span style={valueStyle}>
            {patientData?.patientDetails?.map((item, index) => (
              <div key={index}>: {item?.primaryContactNumber || ""}</div>
            ))}
          </span>
        </div>

        <div style={rowStyle}>
          <span className="right-label-style" style={labelFirstStyle}>
            CONSULTING DOCTOR{" "}
          </span>
          <span style={valueStyle}>
            {renderValue(
              <>
                {patientData?.opdDetails?.consultingDoctorName}
              </>
            )}
          </span>
        </div>

        <div style={rowStyle}>
          <span className="left-label-style" style={labelStyle}>
            ADDRESS{" "}
          </span>
          <span style={valueStyle}>
            {patientData?.patientDetails?.map((item, index) => (
              <div key={index}>
                {renderValue(
                  <>
                    {item?.area?.length > 0 ? item?.area + ", " : ""} {item?.city}
                  </>
                )}
              </div>
            ))}
          </span>
        </div>

        <div style={rowStyle}>
          <span className="right-label-style" style={labelFirstStyle}>
            REG NO{" "}
          </span>
          <span style={valueStyle}>
            : {patientData?.businessInformation?.registrationNumber}
          </span>
        </div>
      </div>
    </>
  );
};

export default PatientDetails;
